<template>
  <div>
    <div class="modal__show-btn" @click="showModal">
      modal (テキストのみ) (セカンダリーボタン) 表示
    </div>
    <TextModalWithSecondary
      v-if="showableModal"
      :title-text="'タイトルが入ります'"
      :caption-text="
        'キャプションエリアです。\n詳細事項を手短に書いてください。'
      "
      :primary-button-text="'プライマリボタン'"
      :secondary-button-text="'セカンダリーボタン'"
      :cancel-button-text="'閉じる'"
      @clicked-modal-cover="closeModal"
      @clicked-primary="clickedPrimary"
      @clicked-secondary="clickedSecondary"
      @clicked-cancel="closeModal"
    />
  </div>
</template>

<script>
import TextModalWithSecondary from '../../components/molecules/modals/with_secondary/text-modal-with-secondary'

export default {
  components: { TextModalWithSecondary },
  data() {
    return {
      showableModal: false
    }
  },
  methods: {
    showModal() {
      this.showableModal = true
    },
    closeModal() {
      this.showableModal = false
    },
    clickedPrimary() {
      window.alert('clicked primary button!')
      this.closeModal()
    },
    clickedSecondary() {
      window.alert('clicked secondary button!')
      this.closeModal()
    }
  }
}
</script>
